import { TenantUserFields } from "../TenantUserFields";
import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";
import { HumanModel } from "./Human";
import { AddressModel } from "./Address";
import { ContactModel } from "./Contact";
import { FieldsModel } from "./Fields";

export class CompanyModel extends Model  {
    public _keys:any = new Array('key', 'appnotmmies');
    name: string = "";
    email: string;
    phone: string;
    mobile: string;
    fax: string;
    legalform: string;
    coc: string;
    startdate: string;
    sbi_code: string;
    sbi_description: string;
    vatid: string;
    key: string;
    
    field_groups:Collection = new Collection();
    fields:Collection = new Collection();
    addresses:Collection = new Collection( [new AddressModel()] );
    contact:Collection = new Collection( [new ContactModel()] );
    constructor(data = null) {
        super(data);
        
        if(data) {
            this.createModel(data,{addresses: AddressModel, fields: FieldsModel});
        }
        
        if( this.addresses.length == 0 ) {
            this.addresses.add( new AddressModel());
        }
        if( this.contact.length == 0 ) {
            this.contact.add( new ContactModel());
        }
        
  //      
    }
 
    public createAddress() {
        //this.addresses.add( new AddressModel());
    }
    
    public addField({...data}) {
        const fieldItem = new FieldsModel(data);
        this.fields.add( fieldItem );
        
        return fieldItem;
    }
    
    public deleteField(uid:string) {
        const fieldModel = this.fields.findOne(uid, 'uid');
        if(fieldModel.key != "") {
            fieldModel.is_deleted = true;
        } else if(!fieldModel.key) {
            this.fields.delete(uid);
        }
    }
}